import React from 'react';
import styled from '@emotion/native';
import Button from '@/shared/components/Button';
import { white } from '@/shared/styles/colors';

interface ModalButtonProps {
  disabled?: boolean;
  loading?: boolean;
  onPress: () => void;
  text: string;
}

const ModalButton: React.FC<ModalButtonProps> = ({
  disabled,
  loading,
  onPress,
  text,
}) => {
  return (
    <ButtonContainer>
      <Button
        disabled={disabled}
        loading={loading}
        onPress={onPress}
        text={text}
      />
    </ButtonContainer>
  );
};

const ButtonContainer = styled.View({
  paddingHorizontal: 16,
  paddingTop: 21,
  paddingBottom: 32,
  backgroundColor: white,
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: -2,
  },
  shadowOpacity: 0.1,
  shadowRadius: 3,
  elevation: 5,
});

export default ModalButton;
